import { writable } from "svelte/store";
import Login from "./Pages/User/Login.svelte";
import Logout from "./Pages/User/Logout.svelte";
import type { SvelteComponent } from "svelte";
import type { RouteDefinition, WrappedComponent } from "svelte-spa-router";
import Prueba from "./Pages/Prueba.svelte";
import PlayerList from "./Pages/PlayerList.svelte";
import CashierList from "./Pages/CashierList.svelte";
import GamesList from "./Pages/GamesList.svelte";
import AddAdmin from "./Components/AddAdmin.svelte";
import EditAdminForm  from "./Components/EditAdminForm.svelte";
import Adminlist from "./Pages/AdminList.svelte";
import Error404 from "./Pages/Error404.svelte";
import Home from "./Pages/Home.svelte";
import administratorlist from "./Pages/AdminList.svelte";
import Transaction from "./Pages/Transaction.svelte";
import GameServerList from "./Pages/GameServerList.svelte";
import GroupList from "./Pages/GroupList.svelte";
import ReportGames from "./Pages/ReportGames.svelte";
import SumReport from "./Pages/SumReport.svelte";
import UnassignedUser from "./Pages/UnassignedUser.svelte";
import GameRoundList from "./Pages/GameRoundList.svelte";
import UserPerfil from "./Pages/UserPerfil.svelte";
import Groups from "./Pages/Groups.svelte";
import BannersList from "./Pages/BannersList.svelte";
import PromotionalCredits from "./Pages/PromotionalCredits.svelte";
import UserbyTransaction from "./Pages/UserbyTransaction.svelte";
import GroupLimit from "./Pages/GroupLimit.svelte";



// interface FrontendRoutes {
//     [key: string]: any
// }

export type MyRouteDefinition = Record<string, typeof SvelteComponent | WrappedComponent>;

const publicPaths = {
    "/": Home,
    "/user/Login" : Login,
    // "/first": AddFirstUser
};

const privatePaths: RouteDefinition = {
    "/Prueba": Prueba,
    "/user/Logout": Logout,
    // "/PlayerList": PlayerList,
    "/Gameslist": GamesList,
    "/Gameslist/:action": GamesList,
    "/Gameslist/:action/:gameid": GamesList,
    "/Adminlist": Adminlist,
    "/AdminList/:action": Adminlist,
    "/Adminlist/:action/:userid": Adminlist,
    // "/CashierList": CashierList,
    "/AddAdmin": AddAdmin,
    "/EditAdminForm": EditAdminForm,
    "/administratorlist": administratorlist,
    "/administratorlist/:action": administratorlist, 
    "/administratorlist/:action/:userid": administratorlist,
    "/CashierList": CashierList,
    "/CashierList/:action": CashierList, 
    "/CashierList/:action/:userid": CashierList,
    "/CashierList/*": CashierList,
    "/PlayerList/:action": PlayerList,
    "/PlayerList/:action/:userid": PlayerList,
    "/PlayerList/*": PlayerList,
    "/PlayerList": PlayerList,

    "/GroupList/:action": GroupList,
    "/GroupList/:action/:groupid": GroupList,
    "/GroupList/*": GroupList,
    "/GroupList": GroupList,

    "/ReportGames/:action": ReportGames,
    "/ReportGames/:action/:gameid": ReportGames,
    "/ReportGames/*": ReportGames,
    "/ReportGames": ReportGames,

    "/GameServerList": GameServerList,
    "/GameServerList/:action": GameServerList,
    "/GameServerList/:action/:serverid": GameServerList,

    "/Transaction": Transaction,
    "/SumReport": SumReport,

    "/UnassignedUser": UnassignedUser,
    "/UnassignedUser/:action": UnassignedUser,
    "/UnassignedUser/:action/:userid": UnassignedUser,

    "/GameRoundList": GameRoundList,
    "/GameRoundList/:action": GameRoundList,
    "/GameRoundList/:action/:roundid": GameRoundList,

    "/Groups:action": Groups,
    "/Groups/:action/:groupid": Groups,
    "/Groups/*": Groups,
    "/Groups": Groups,

    "/BannersList/:action": BannersList,
    "/BannersList/:action/:bannerid": BannersList,
    "/BannersList/*": BannersList,
    "/BannersList": BannersList,


    "/PromotionalCredits/:action": PromotionalCredits,
    "/PromotionalCredits/:action/:promotionalcreditsid": PromotionalCredits,
    "/PromotionalCredits/*": PromotionalCredits,
    "/PromotionalCredits": PromotionalCredits,

    "/UserbyTransaction/:action": UserbyTransaction,
    "/UserbyTransaction/:action/:userid": UserbyTransaction,
    "/UserbyTransaction/*": UserbyTransaction,
    "/UserbyTransaction": UserbyTransaction,

    "/GroupLimit/:action": GroupLimit,
    "/GroupLimit/:action/:groupid": GroupLimit,
    "/GroupLimit/*": GroupLimit,
    "/GroupLimit": GroupLimit,

    "/UserPerfil": UserPerfil,   


    "/": Home,
    "*": Error404
}


const notFound: RouteDefinition = {
    //'*': NotFound,
}

export const routes = writable({});
routes.set({
    ...publicPaths,
    ...privatePaths,
    ...notFound
});
